const lostItemsRoutes = [
  {
    path: "lostItems",
    name: "Lost Items",
    redirect: {
      name: "List Lost Items"
    },
    component: () =>
      import(
        /* webpackChunkName: "lostItems" */ "../../views/lostItems/LostItems.vue"
      ),
    children: [
      {
        path: "list",
        name: "List Lost Items",
        component: () =>
          import(
            /* webpackChunkName: "lostItems" */ "../../views/lostItems/LostItemsList.vue"
          )
      },
      {
        path: "detail/:id",
        name: "Lost Item Detail",
        component: () =>
          import(
            /* webpackChunkName: "lostItems" */ "../../views/lostItems/LostItemDetail.vue"
          )
      },
      {
        path: "instructions",
        name: "Lost Items Instructions",
        component: () =>
          import(
            /* webpackChunkName: "lostItems" */ "../../views/lostItems/Instructions.vue"
          )
      }
    ]
  }
];

export default lostItemsRoutes;
